export default {
  taxes: [],
  selectedTax: {},
  action: '',
  isDisabled: false,
  taxRegimes: [],
  taxHistory: {},
  params: {
    page: 1,
    perPage: 50,
    filter: ''
  }
}



// WEBPACK FOOTER //
// ./src/modules/taxes/state.js